<div id="section-movil">
  <div class="container">
    <div class="row" id="scene3">
      <div class="col-md-12 text-center" data-depth="0.10">
        <div class="title">
          <h1>{{ titleKey | translate }}</h1>
          <h4>{{ subtitleKey | translate }}</h4>
        </div>
        <div class="corner-left"></div>
        <div class="corner-right"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 pt-4">
        @for (item of items; track item) {
          <div class="item-circle">
            <div class="icon">
              <fa-icon [icon]="item.icon"></fa-icon>
            </div>
            <div class="item-body">
              <div>{{ item.titleKey | translate }}</div>
              <p>{{ item.textKey | translate }}</p>
              <br />
            </div>
          </div>
        }
      </div>
      <div id="scene3phone" class="col-lg-6 text-center">
        <img class="phoneFront" src="/assets/img/phoneFront.png" data-depth="0.50" alt="" />
        <img class="phoneBack" src="/assets/img/phoneBack.png" alt="" />
      </div>
    </div>
  </div>
</div>
